import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {route} from '../../../conf/routes'
import {_CRUD} from './_Action'
import {_PAGINATE} from './paginateAction'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import { _ECOWATCH } from './ecoWatchAction'

export const NEWS = 'news'
export const NEWS_FEATURED = 'news_featured'
export const CLOUDS = 'clouds'

const _NEWS = _CRUD(NEWS)
const _NEWS_PAGINATE = _PAGINATE(NEWS)
const _NEWS_FEATURED = _CRUD(NEWS_FEATURED)
const _CLOUDS = _CRUD(CLOUDS)

/* News with tag PME CHANGE or PME DETTE or PME PLACEMENT and veille éco */
export const NEWS_PME = 'newsPME'
const _NEWS_PME_ECOWATCH = _ECOWATCH(NEWS_PME)
/* News with tag POINTS or FOCUS or PERSPECTIVES and veille éco */
export const NEWS_FPP = 'newsFPP'
const _NEWS_FPP_ECOWATCH = _ECOWATCH(NEWS_FPP)
/* News hasn't tag POINTS NOR FOCUS NOR PERSPECTIVES NOR PME CHANGE NOR PME DETTE NOR PME PLACEMENT and veille éco*/
export const NEWS_HEBDO = 'newsHEBDO'
const _NEWS_HEBDO_ECOWATCH = _ECOWATCH(NEWS_HEBDO)

export const getNews = (id: string) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [_NEWS.GET.REQUEST, _NEWS.GET.SUCCESS, _NEWS.GET.FAILURE],
      route: route.news.get(id)
    }
  })
}

export const fetchNews = (c: NewsCriteria) => (dispatch, getState: () => RootState) => {
    c.order_by = 'desc'
    c.sort_by = 'publish_at'
    c.target_id=null
    return dispatch({
      [_CALL_API]: {
        types: [_NEWS_PAGINATE.REQUEST, _NEWS_PAGINATE.SUCCESS, _NEWS_PAGINATE.FAILURE],
        route: route.news.search(c)
      }
    })
}

export const fetchMoreNews = (c: NewsCriteria) => (dispatch, getState: () => RootState) => {
  c.order_by = 'desc'
  c.sort_by = 'publish_at'
  c.target_id=null
  return dispatch({
    [_CALL_API]: {
      types: [_NEWS_PAGINATE.FETCH_MORE_REQUEST, _NEWS_PAGINATE.FETCH_MORE_SUCCESS, _NEWS_PAGINATE.FETCH_MORE_FAILURE],
      route: route.news.search(c)
    }
  })
}

export const fetchNewsEcoWatch = (c: NewsCriteria, tagPrincipal: string) => (dispatch, getState: () => RootState) => {
  c.order_by = 'desc'
  c.sort_by = 'publish_at'
  c.target_id=null
  switch(tagPrincipal){
    case 'PME':
      return dispatch({
        [_CALL_API]: {
          types: [_NEWS_PME_ECOWATCH.REQUEST, _NEWS_PME_ECOWATCH.SUCCESS, _NEWS_PME_ECOWATCH.FAILURE],
          route: route.news.search(c)
        }
      })
    case 'FPP':
      return dispatch({
        [_CALL_API]: {
          types: [_NEWS_FPP_ECOWATCH.REQUEST, _NEWS_FPP_ECOWATCH.SUCCESS, _NEWS_FPP_ECOWATCH.FAILURE],
          route: route.news.search(c)
        }
      })
    case 'HEBDO':
      return dispatch({
        [_CALL_API]: {
          types: [_NEWS_HEBDO_ECOWATCH.REQUEST, _NEWS_HEBDO_ECOWATCH.SUCCESS, _NEWS_HEBDO_ECOWATCH.FAILURE],
          route: route.news.search(c)
        }
      })
    default:
      return fetchNews(c);
  }
}

export const fetchNewsFeatured = (criteria: any) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [_NEWS_FEATURED.GET.REQUEST, _NEWS_FEATURED.GET.SUCCESS, _NEWS_FEATURED.GET.FAILURE],
      route: route.news.searchFeatured({...criteria, ...{is_highlighted: true, limit: 1, target_id: null}})
    }
  })
}

export const fetchNewsFeaturedPrevent = (criteria: any) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [_NEWS_FEATURED.GET.REQUEST, _NEWS_FEATURED.GET.SUCCESS, _NEWS_FEATURED.GET.FAILURE],
      route: route.news.searchFeaturedPrevent({...criteria, ...{sort_by: 'publish_at', order_by: 'desc', limit: 1,  target_id: null}})
    }
  })
}

export const getClouds = (c?: NewsCriteria) => (dispatch, getState: () => RootState) => {
  return dispatch({
    [_CALL_API]: {
      types: [_CLOUDS.GET.REQUEST, _CLOUDS.GET.SUCCESS, _CLOUDS.GET.FAILURE],
      route: route.news.getCloud(c)
    }
  })
}




// WEBPACK FOOTER //
// ./src/core/redux/action/newsAction.ts